/* eslint-disable camelcase */
import React from 'react';
import {connect} from 'react-redux';
import {
  Layout,
  Link,
  TextStyle,
  FooterHelp,
  Button,
  TextContainer,
  DisplayText,
} from '@shopify/polaris';
import {StepsFooterHelp} from './helpers/footer_help';
import {Routes} from 'sections/services-marketplace/experts/utilities';

interface OwnProps {
  brief: {
    id: string;
    subcategory_short_label: string;
    shop_permanent_domain: string;
  };
  organization?: {
    businessName: string;
  };
  browseContext: boolean;
}

function Confirmation({
  brief: {id, subcategory_short_label, shop_permanent_domain},
  organization,
  browseContext,
}: OwnProps) {
  const {submission: help} = StepsFooterHelp;

  const confirmationText =
    organization && organization.businessName
      ? `Your job for ${subcategory_short_label} has been sent to ${organization.businessName}.`
      : `Your job for ${subcategory_short_label} has been sent to the best matched experts.`;

  const redirectToDashboardText = browseContext ? (
    <TextStyle variation="subdued">
      {' '}
      Manage your job and view expert responses in your Shopify admin.
    </TextStyle>
  ) : null;

  function handleOnClick() {
    window.location.assign(Routes.jobPath(shop_permanent_domain, id));
  }

  return (
    <Layout.Section>
      <div className="Confirmation">
        <div className="ConfirmationImage">
          <img src={Routes.imagePath('svg/job_sent.svg')} alt="" />
        </div>
        <div className="ConfirmationText">
          <TextContainer spacing="tight">
            <DisplayText element="h2" size="large">
              Job sent
            </DisplayText>
            <DisplayText element="p" size="small">
              <TextStyle variation="subdued">{confirmationText}</TextStyle>
              {redirectToDashboardText}
            </DisplayText>
          </TextContainer>
          <Button primary onClick={handleOnClick}>
            View job
          </Button>
        </div>
      </div>
      <Layout.AnnotatedSection />
      {help ? (
        <FooterHelp>
          Learn more about{' '}
          <Link url={help.url} external>
            {help.about}
          </Link>
          .
        </FooterHelp>
      ) : null}
    </Layout.Section>
  );
}

function mapStateToProps(store: any) {
  const {
    progress: {brief},
    context: {organization, browseContext},
  } = store;

  return {
    organization,
    brief,
    browseContext,
  };
}

export default connect(mapStateToProps)(Confirmation);
